<template>
  <v-sheet
    class="d-flex flex-column bg-grey-darken-2 justify-center pt-6 mapBack w-100 pb-10"
    :class="width > 1000 ? 'text-body' : 'text-body-2'"
    :style="`background-image: url(${backhillshades})`"
  >
    <v-sheet
      width="100%"
      :max-width="width < 1000 ? '100%' : '1700px'"
      class="d-flex bg-transparent align-stretch justify-space-between mx-auto px-6"
      :class="width > 800 ? 'flex-row' : 'flex-column'"
    >
      <v-sheet
        class="d-flex align-start justify-left bg-transparent"
        :class="width > 800 ? 'flex-column' : 'flex-row flex-wrap'"
      >
        <v-card
          :to="{ path: `/information/ueberwaldatlas` }"
          variant="text"
          class="justify-start pa-2"
          max-width="200px"
          >Über WALDATLAS</v-card
        >
        <v-card
          :to="{ path: `/topics` }"
          variant="text"
          class="justify-start pa-2"
          max-width="200px"
          >Themen und Suche</v-card
        >
        <v-card
          :to="{ path: `/map/${randomMapId}` }"
          variant="text"
          class="justify-start pa-2"
          max-width="200px"
          >Beispielkarte</v-card
        >
      </v-sheet>
      <v-sheet
        class="d-flex align-start justify-left bg-transparent"
        :class="width > 800 ? 'flex-column' : 'flex-row flex-wrap mt-5'"
      >
        <v-card
          :to="{ path: `/information/wissenswertes` }"
          variant="text"
          class="justify-start pa-2"
          max-width="200px"
          >Wissenswerte Fakten</v-card
        >
        <v-card
          :to="{ path: `/information/plattformen` }"
          variant="text"
          class="justify-start pa-2"
          max-width="200px"
          >Weitere Plattformen</v-card
        >
        <v-card
          :to="{ path: `/information/opendatainspire` }"
          variant="text"
          class="justify-start pa-2"
          max-width="200px"
          >Open Data / Inspire</v-card
        >
      </v-sheet>
      <v-sheet
        class="d-flex align-start justify-left bg-transparent"
        :class="width > 800 ? 'flex-column' : 'flex-row flex-wrap mt-5'"
      >
        <v-card
          :to="{ path: `/information/kontakt` }"
          variant="text"
          class="justify-start pa-2"
          max-width="200px"
          >Kontakt</v-card
        >
        <v-card
          :to="{ path: `/information/haftungsausschluss` }"
          variant="text"
          class="justify-start pa-2"
          max-width="200px"
          >Haftungsausschluss</v-card
        >
        <v-card
          :to="{ path: `/information/impressum` }"
          variant="text"
          class="justify-start pa-2"
          max-width="200px"
          >Impressum</v-card
        >
        <v-card
          :to="{ path: `/information/datenschutz` }"
          variant="text"
          class="justify-start pa-2"
          max-width="200px"
          >Datenschutzinformation</v-card
        >
        <v-card
          :to="{ path: `/information/barrierefreiheit` }"
          variant="text"
          class="justify-start pa-2"
          max-width="200px"
          >Barrierefreiheitserklärung</v-card
        >
      </v-sheet>
      <v-sheet
        class="d-flex align-start justify-left bg-transparent"
        :class="width > 800 ? 'flex-column' : 'flex-row mt-10'"
      >
        <a
          href="https://www.bmluk.gv.at/"
          class="d-block"
          aria-label="Link zu BML"
          ><v-img
            :src="logobml"
            :max-width="width > 1000 ? '230px' : '140px'"
            :width="width > 1000 ? '230px' : '140px'"
        /></a>
        <v-spacer v-if="width < 801" />
        <v-img
          height="auto"
          :src="logowaldatlas"
          :width="width > 1000 ? '230px' : '140px'"
          :max-width="width > 1000 ? '230px' : '140px'"
          max-height="100px"
          style="margin-left: 1px"
        />
      </v-sheet>
    </v-sheet>
    <v-sheet class="w-100 d-flex bg-transparent justify-end pb-2 pt-8">
      <v-card
        class="d-flex mr-2 text-body-2"
        variant="text"
        href="https://www.bmluk.gv.at/"
        >&copy; {{ theCurrentYear }} BMLUK.gv.at - Alle Rechte
        vorbehalten</v-card
      ></v-sheet
    >
  </v-sheet>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useDisplay } from 'vuetify';
import logobml from '../assets/BML_Logo_weiss.png';
import logowaldatlas from '../assets/logo-waldatlas-weiss.png';
import backhillshades from '../assets/landing/back-hillshading-2.jpg';
import { useRandomMap } from '../composables/useRandomMap.js';

const { width } = useDisplay();
const { randomMapId } = useRandomMap();
const theCurrentYear = ref('');

onMounted(() => {
  theCurrentYear.value = `2023 - ${new Date().getFullYear()}`;
});
</script>

<style scoped>
.mapBack {
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
}
</style>
